const initialState = {
  loading: false,
  team: [],
  error: null,
  selectedMember: null,
};

const teamReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_TEAM_REQUEST":
      return { ...state, loading: true, error: null };
    case "FETCH_TEAM_SUCCESS":
      return { ...state, loading: false, team: action.payload || [] };
    case "FETCH_TEAM_FAILURE":
      return { ...state, loading: false, error: action.payload };

      case "SAVE_TEAM_SUCCESS":
        return {
          ...state,
          team: [...(state.team || []), action.payload],
        };
      

    case "UPDATE_TEAM_SUCCESS":
      return {
        ...state,
        team: state.team.map((m) =>
          m.memberObjId === action.payload.memberObjId ? action.payload : m
        ),
      };

    case "DELETE_TEAM_SUCCESS":
      return {
        ...state,
        team: state.team.filter((m) => m.memberObjId !== action.payload.memberObjId),
      };

    default:
      return state;
  }
};

export default teamReducer;
